<template>
  <div class="relative">
    <div ref="reference" class="peer">
      <slot />
    </div>
    <p
      ref="floating"
      class="px-2 hidden data-[show]:block py-1 text-sm shadow-[0px_5px_15px_0px_rgba(0,0,0,0.2)] rounded-xs bg-white z-30"
      :style="floatingStyles"
      :class="{
        'w-80': content?.length > 50,
        'w-60': content?.length > 30,
        'w-40': content?.length > 15,
      }"
    >
      {{ content }}
    </p>
  </div>
</template>

<script setup>
import { useFloating, offset } from "@floating-ui/vue";
import { onBeforeUnmount, onMounted, ref } from "vue";

defineProps({
  content: String,
  origin: {
    type: String,
    default: "left",
  },
});

const reference = ref(null);
const floating = ref(null);
const { floatingStyles, update } = useFloating(reference, floating, {
  placement: "left",
  middleware: [offset(5)],
  strategy: "fixed",
});

function show() {
  floating.value.setAttribute("data-show", "");

  // We need to tell Popper to update the tooltip position
  // after we show the tooltip, otherwise it will be incorrect
  update();
}

function hide() {
  floating.value.removeAttribute("data-show");
}

const showEvents = ["mouseenter", "focus"];
const hideEvents = ["mouseleave", "blur"];

onMounted(() => {
  showEvents.forEach((event) => {
    reference.value.addEventListener(event, show);
  });

  hideEvents.forEach((event) => {
    reference.value.addEventListener(event, hide);
  });
});

onBeforeUnmount(() => {
  showEvents.forEach((event) => {
    reference.value.removeEventListener(event, show);
  });

  hideEvents.forEach((event) => {
    reference.value.removeEventListener(event, hide);
  });
});
</script>
